import type React from 'react';

import { cn } from '@change/ds-utils';

type Props = {
	children: React.ReactNode;
	className?: string;
};

export const ToastBanner: React.FC<Props> = ({ children, className, ...rest }) => {
	return (
		<div className={cn('flex w-full gap-4', className)} {...rest}>
			{children}
		</div>
	);
};
